import PullableWrapper from '@/components/PullableWrapper';
import PWALayout from '@/layouts/AlphaLayout';
import JackpotPlayerShares from '@/modules/AlphaPWA/PlayerShares';
import { NextPage } from 'next';
import React from 'react';

const PlayerShares: NextPage = () => {
  return (
    <PullableWrapper>
      <PWALayout>
        <JackpotPlayerShares />
      </PWALayout>
    </PullableWrapper>
  );
};

export default PlayerShares;
